import SuperuserDashboardComponent from '../components/dashboard/superuser';

export default function SuperuserDashboard() {
  return <SuperuserDashboardComponent />;
}
